// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"GK-z","carouselContainer":"HK-z"};